const initCardSliderWidget = () => {
    const selectorT1 = "[data-card-slider-widget].typology-1 [data-carousel]";
    const carouselT1 = document.querySelector(selectorT1);
    const internalGallerySelector = "[data-card-slider-widget] [data-internal-gallery]";
    const internalGallery = document.querySelector(internalGallerySelector);
    const selectorT2 = "[data-card-slider-widget].typology-2 [data-carousel]";
    const carouselT2 = document.querySelector(selectorT2);
    const selectorT3 = "[data-card-slider-widget].typology-3 [data-carousel]";
    const carouselT3 = document.querySelector(selectorT3);
    const selectorT5 = "[data-card-slider-widget].typology-5 [data-carousel]";
    const carouselT5 = document.querySelector(selectorT5);
    const selectorT8 = "[data-card-slider-widget].typology-8 [data-carousel]";
    const carouselT8 = document.querySelector(selectorT8);
    let config = new CarouselConfig();
    const responsiveCarousel = new ResponsiveCarousel();
    let autoplay = false;
    //typology-1
    if (carouselT1) {
        if (carouselT1.children.length > 4) {
            autoplay = true;
        }
        else {
            carouselT1.parentNode.lastElementChild.classList.add("hide-button");
        }
        if (internalGallery) {
            setTimeout(() => {
                config = new CarouselConfig();
                config.sliderSelector = internalGallerySelector;
                config.cellAlign = CellAlign.center;
                config.contain = true;
                config.autoPlay = autoplay;
                config.wrapAround = true;
                config.showArrows = false;
                config.adaptiveHeight = false;
                config.showDots = false;
                config.groupCells = false;
                config.adaptiveHeight = false;
                config.imagesLoaded = false;
                config.activateCustomButtons = true;
                config.notDraggable = !autoplay;
                const createdGalleryArray = responsiveCarousel.initCarousel(config);
            }, 200);
        }
        setTimeout(() => {
            config = new CarouselConfig();
            config.sliderSelector = selectorT1;
            config.cellAlign = CellAlign.left;
            config.contain = true;
            config.autoPlay = autoplay;
            config.wrapAround = true;
            config.showArrows = false;
            config.adaptiveHeight = false;
            config.showDots = false;
            config.groupCells = false;
            config.imagesLoaded = true;
            config.activateCustomButtons = autoplay;
            config.sameCardHeight = true;
            config.notDraggable = !autoplay;
            const createdSliderArray = responsiveCarousel.initCarousel(config);
        }, 200);
    }
    if (carouselT2 && window.innerWidth < 767) {
        config.sliderSelector = selectorT2;
        config.cellAlign = window.innerWidth > 767 ? CellAlign.left : CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = true;
        config.showArrows = false;
        config.adaptiveHeight = true;
        config.showDots = window.innerWidth <= 767 ? true : false;
        config.groupCells = false;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        config.activateCustomButtons = window.innerWidth > 767 ? true : false;
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
    }
    if (carouselT3) {
        config.sliderSelector = selectorT3;
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = true;
        config.showArrows = false;
        config.adaptiveHeight = true;
        config.showDots = true;
        config.groupCells = false;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        config.activateCustomButtons = false;
        config.sameCardHeight = true;
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
    }
    if (carouselT5) {
        config.sliderSelector = selectorT5;
        config.cellAlign = CellAlign.left;
        config.contain = false;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.adaptiveHeight = true;
        config.showDots = false;
        config.groupCells = false;
        config.imagesLoaded = true;
        config.activateCustomButtons = true;
        config.activateCustomCounter = true;
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
        const previewGallery = document.createElement("div");
        const wrapper = document.createElement("div");
        wrapper.classList.add("wrapper");
        wrapper.setAttribute("data-carousel", null);
        previewGallery.classList.add("preview-gallery");
        createdCarouselsArray.forEach(carousel => {
            const HTMLCarousel = carousel.slider;
            const clone = HTMLCarousel.cloneNode(true);
            const slides = clone.querySelectorAll(":scope > [data-slide]");
            //add slides to preview gallery
            slides.forEach(slide => {
                wrapper.append(slide);
            });
            previewGallery.appendChild(wrapper);
            HTMLCarousel.parentElement.appendChild(previewGallery);
            previewGallery.classList.add("active");
            config.sliderSelector = ".preview-gallery .wrapper";
            config.cellAlign = CellAlign.left;
            config.contain = false;
            config.autoPlay = false;
            config.wrapAround = false;
            config.showArrows = false;
            config.adaptiveHeight = true;
            config.showDots = false;
            config.groupCells = false;
            config.imagesLoaded = true;
            config.activateCustomButtons = false;
            config.activateCustomCounter = false;
            const createdSliderPromise = new Promise((resolve) => {
                const createdSlider = responsiveCarousel.initCarousel(config)[0];
                resolve(createdSlider);
            });
            createdSliderPromise.then((createdSlider) => {
                if (createdSlider !== undefined) {
                    createdSlider.select(createdSlider.selectedIndex + 1);
                }
            });
            carousel.on("change", (index) => {
                if ((index + 1) == carousel.cells.length) {
                    previewGallery.classList.remove("active");
                }
                else {
                    previewGallery.classList.add("active");
                    createdSliderPromise.then((createdSlider) => {
                        createdSlider.select(index + 1);
                    });
                }
            });
        });
    }
    if (carouselT8 && window.innerWidth < 767) {
        const config = new CarouselConfig();
        config.sliderSelector = selectorT8;
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showDots = false;
        config.groupCells = false;
        config.adaptiveHeight = true;
        config.imagesLoaded = true;
        config.activateCustomButtons = false;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
